import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  // Add your routes here
  { path: '', redirectTo: '/home', pathMatch: 'full' }, // Rotta di reindirizzamento
  { path: 'home', component: HomeComponent }, // Rotta per la home
  { path: 'dashboard', component: DashboardComponent }, // Rotta protetta, accessibile solo se autenticato
];
